import { memo } from 'react';

export const genericMemo: <Type>(component: Type) => Type = memo;
